import { useState, useEffect } from 'react';

export default function TenantModal({ isOpen, onClose, onSave, editData, title, isLoading = false, isViewMode = false }) {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        status: 'active'
    });

    useEffect(() => {
        if (editData) {
            setFormData({
                name: editData.name || '',
                description: editData.description || '',
                status: editData.status || 'active'
            });
        } else {
            setFormData({
                name: '',
                description: '',
                // status: 'active'
            });
        }
    }, [editData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // API expects tenant_name and tenant_description for create/update
        const payload = {
            tenant_name: formData.name,
            tenant_description: formData.description,
            // status: formData.status
        };
        onSave(payload);
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
                <div className='py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light'>
                    <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                        {title}
                    </h5>
                    <form onSubmit={handleSubmit}>
                        <div className='my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar'>
                            <div className='grid grid-cols-12 gap-20'>
                                <div className='form-group flex flex-col col-span-12'>
                                    <label htmlFor='name' className='mb-5 text-sm font-medium'>
                                        Tenant Name <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='name'
                                        name='name'
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder='Enter tenant name'
                                        required
                                        disabled={isViewMode}
                                        className={isViewMode ? 'bg-gray-100 cursor-not-allowed' : ''}
                                    />
                                </div>
                                <div className='form-group flex flex-col col-span-12'>
                                    <label htmlFor='description' className='mb-5 text-sm font-medium'>
                                        Description
                                    </label>
                                    <textarea
                                        id='description'
                                        name='description'
                                        value={formData.description}
                                        onChange={handleChange}
                                        rows={3}
                                        className={`bg-bg-light border border-border w-full py-[6px] px-3 min-h-[80px] rounded-[4px] placeholder:text-text-secondary focus:outline-none resize-none ${isViewMode ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        disabled={isViewMode}
                                    />
                                </div>
                                {/* <div className='form-group flex flex-col col-span-12'>
                                    <label htmlFor='status' className='mb-5 text-sm font-medium'>
                                        Status <span className='text-danger'>*</span>
                                    </label>
                                    <select
                                        id='status'
                                        name='status'
                                        value={formData.status}
                                        onChange={handleChange}
                                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] focus:outline-none'
                                    >
                                        <option value='active'>Active</option>
                                        <option value='inactive'>Inactive</option>
                                    </select>
                                </div> */}
                            </div>
                        </div>
                        <div className='md:px-10 px-[7px] flex gap-10 justify-end py-10'>
                            <button type='button' onClick={onClose} className='btn btn-outline-secondary' disabled={isLoading}>
                                {isViewMode ? 'Close' : 'Cancel'}
                            </button>
                            {!isViewMode && (
                                <button type='submit' className='btn btn-primary' disabled={isLoading}>
                                    {isLoading ? 'Saving...' : (editData ? 'Update' : 'Submit')}
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            <div onClick={onClose} className='fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]'></div>
        </>
    );
}
